// WI#43/#44 — the server refuses a NEW account outside the US/Canada with 403 region_unavailable,
// and says why: outside_region (a final answer) or lookup_failed (no usable location — VPN, Tor —
// so the person can try again). The region page shows the matching state.
// #84 adds origin_untrusted: no trusted Cloudflare header reached us at all. That is OUR routing
// problem (e.g. the Cloudflare rule stopped setting our header), not the visitor's VPN, so it shows
// the check_failed wording. Unknown reasons must never fall through to "not available in your region".
export type RegionRefusalReason = "outside_region" | "lookup_failed" | "origin_untrusted";

export function regionRefusal(status: number | undefined, data: unknown): RegionRefusalReason | null {
  const d = data as { code?: string; reason?: string } | null | undefined;
  if (status !== 403 || d?.code !== "region_unavailable") return null;
  if (d.reason === "lookup_failed" || d.reason === "origin_untrusted") return d.reason;
  return "outside_region";
}

export function regionPath(reason: RegionRefusalReason): string {
  return reason === "outside_region" ? "/region" : `/region?reason=${reason}`;
}

// What the region page shows. check_failed is OUR failure — the region check itself didn't answer —
// so it gets its own temporary-service message rather than VPN advice (Kayla J4, three states;
// Emily R2). It only arises on the sign-up page; the server never refuses with it.
export type RegionPageState = RegionRefusalReason | "check_failed";

// The sign-up page's answer to GET /api/region.
export function signUpRegionState(
  check: { isError: boolean; data?: { allowed: boolean; reason: string } | null },
): "allowed" | RegionPageState {
  if (check.isError || !check.data) return "check_failed";
  if (check.data.reason === "lookup_failed" || check.data.reason === "origin_untrusted") return check.data.reason;
  return check.data.allowed ? "allowed" : "outside_region";
}
